"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportUserResponseToJSON = exports.ImportUserResponseFromJSONTyped = exports.ImportUserResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ImportUserResponseFromJSON(json) {
    return ImportUserResponseFromJSONTyped(json, false);
}
exports.ImportUserResponseFromJSON = ImportUserResponseFromJSON;
function ImportUserResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'results': !(0, runtime_1.exists)(json, 'results') ? undefined : (json['results'].map(_1.ImportUserResponseItemFromJSON)),
    };
}
exports.ImportUserResponseFromJSONTyped = ImportUserResponseFromJSONTyped;
function ImportUserResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'results': value.results === undefined ? undefined : (value.results.map(_1.ImportUserResponseItemToJSON)),
    };
}
exports.ImportUserResponseToJSON = ImportUserResponseToJSON;
